import { IUseGetMyPopularTractorParams } from '../../../hooks/api/user/queries/useGetMyPopularTractor';
import { IMyPopularTractor } from '../../../interfaces/OwnTractor.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';
import { myOwnTractorsApiUrl } from './getMyOwnTractors';

export const myPopularTractorApiUrl = myOwnTractorsApiUrl + '/popular';

type IGetMyPopularTractorParams = Pick<IUseGetMyPopularTractorParams, 'searchParam'>;

export const getMyPopularTractor = ({ searchParam }: IGetMyPopularTractorParams): Promise<IMyPopularTractor> => {
  const URLSearchParams = createURLSearchParams({ ...searchParam, isPokeEnabled: searchParam.isPokeEnabled ?? '' });
  return customAxios.get(`${myPopularTractorApiUrl}/?${URLSearchParams}`);
};
